import { render, staticRenderFns } from "./ModalBuscarFamilia.vue?vue&type=template&id=4cee119a"
import script from "./ModalBuscarFamilia.vue?vue&type=script&lang=js"
export * from "./ModalBuscarFamilia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports